import Nav from "./components/nav/Nav";
import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";

function App({
  children,
  header = <Nav />,
}: {
  children: ReactNode;
  header?: ReactNode;
}) {
  return (
    <>
      {header}
      {children}
    </>
  );
}

export default Sentry.withProfiler(App);
